import { MoveFrontConfig } from 'game/core'

export const move_front_config: Array<MoveFrontConfig> = [
    {
        available: 0,
        cooldown: 0,
        energy: 1
    }
]